import { TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Text } from '../../text';

/**
 * DropdownMenu用の削除メニューアイテム表示コンポーネント
 *
 * TrashIconアイコン + 赤文字の「削除」ラベルを統一的に表示する
 */
export const DropdownMenuDeleteItem = () => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center">
      <TrashIcon className="mr-2 h-4 w-4 text-text-error" />
      <Text color="error">{t('common.actions.delete')}</Text>
    </div>
  );
};
